import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  class: "flex flex-col gap-8 bg-white p-4 rounded-md shadow-weak_material text-xs"
};
const _hoisted_2 = {
  class: "flex items-center justify-between border-b border-main-100/20 pb-1"
};
const _hoisted_3 = {
  class: "font-semibold"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "flex gap-2"
};
const _hoisted_6 = {
  class: "w-full max-w-[120px] flex flex-col gap-1 text-main-75 text-xs"
};
const _hoisted_7 = ["onUpdate:modelValue"];
const _hoisted_8 = {
  class: "w-full max-w-[120px] flex flex-col gap-1 text-main-75 text-xs"
};
const _hoisted_9 = ["onUpdate:modelValue"];
export default {
  __name: 'FiltersBuilder',
  props: {
    config: Object
  },
  setup(__props) {
    const props = __props;
    props.config.forEach(f => {
      switch (f.type) {
        case 'date-range':
          f.clear = () => f.value = [];
          if (!f.value) {
            f.clear();
          }
          if (f.key) {
            f.toQuery = () => `${f.key}=${f.value?.[0] ?? ''}..${f.value?.[1] ?? ''}`;
          }
          break;
        default:
          f.clear = () => f.value = undefined;
          f.clear();
          if (f.key) {
            f.toQuery = () => `${f.key}=${f.value}`;
          }
          break;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.config, filter => {
        return _openBlock(), _createElementBlock("div", {
          key: filter,
          class: "flex flex-col gap-3"
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString(filter.label), 1), _createElementVNode("i", {
          class: "icon-trash text-lg text-main-75 cursor-pointer hover:text-main-100 transition-colors",
          onClick: $event => {
            filter.clear();
            filter.onClear?.();
          }
        }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("p", null, _toDisplayString(_ctx.$st('general.from')), 1), _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "bg-transparent border border-main-50 rounded p-2",
          "onUpdate:modelValue": $event => filter.value[0] = $event
        }, null, 8, _hoisted_7), [[_vModelText, filter.value[0]]])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("p", null, _toDisplayString(_ctx.$st('general.to')), 1), _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "bg-transparent border border-main-50 rounded p-2",
          "onUpdate:modelValue": $event => filter.value[1] = $event
        }, null, 8, _hoisted_9), [[_vModelText, filter.value[1]]])])])]);
      }), 128)), _renderSlot(_ctx.$slots, "default")]);
    };
  }
};